import React from 'react';
import PageHero from '../components/PageHero';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { services } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";



const ServicesPage = () => {
  const breadcrumbItems = [
    { label: 'HOME', path: '/' },
    { label: 'SERVICES' }
  ];

  return (
    <div className="page-wrapper">
      <BreadcrumbSchema items={breadcrumbItems} />
      
      <PageHero 
        title="Advanced Engineering Services"
        breadcrumbItems={breadcrumbItems}
        subtitle="Precision manufacturing solutions from concept to production"
      />
      
      <section className="page-content-section">
        <div className="container-modern">
          <div className="services-detail-grid">
            {services.map((service) => (
              <div key={service.id} className="service-detail-card">
                <Link to={`/services/${service.slug}`} className="service-detail-link">
                  <div className="service-detail-image">
                    <img src={service.image} alt={service.title} />
                    <div className="service-detail-overlay"></div>
                  </div>
                  <div className="service-detail-content">
                    <h2 className="service-detail-title">{service.title}</h2>
                    <p className="service-detail-description">{service.description}</p>
                    
                    {service.materials && (
                      <div className="service-detail-info">
                        <h3 className="info-heading">Materials</h3>
                        <p className="info-text">{service.materials}</p>
                      </div>
                    )}
                    
                    {service.capabilities && (
                      <div className="service-detail-info">
                        <h3 className="info-heading">Capabilities</h3>
                        <ul className="info-list">
                          {service.capabilities.map((cap, idx) => (
                            <li key={idx}>
                              <CheckCircle2 className="list-icon" />
                              {cap}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    <div className="service-detail-info">
                      <h3 className="info-heading">Applications</h3>
                      <p className="info-text">{service.applications}</p>
                    </div>
                    
                    <div className="service-learn-more">
                      Learn More →
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default ServicesPage;
